<template>
  <el-container style="width: 100%">
    <el-header>
      <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
      <el-button round @click="refreshClick">{{generateCustomizeString('refresh')}}</el-button>
    </el-header>
    <el-table :data="warehouseData" tooltip-effect="dark" style="width: 96%; margin: 20px auto;" v-loading.body="warehouseListLoading">
      <el-table-column prop="name" :label="generateCustomizeString('warehouseName')">
      </el-table-column>
      <el-table-column prop="address" :label="generateCustomizeString('warehouseAddress')">
      </el-table-column>
      <el-table-column fixed="right" :label="generateCustomizeString('operate')" width="180">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" type="text" size="small">{{generateCustomizeString('edit')}}</el-button>
          <el-button type="text" size="small" @click="deleteClick(scope.row)">{{generateCustomizeString('delete')}}</el-button>
          <el-dialog :title="generateCustomizeString('confirm')" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
            <span>{{ generateCustomizeString('deleteWarehouse') }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisible = false">{{ generateCustomizeString('cancel') }}</el-button>
              <el-button type="primary" @click="deleteWarehouse()">{{ generateCustomizeString('confirm') }}</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:15px;">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="15" layout="total, prev, pager, next" :total="currentTotal">
      </el-pagination>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'Warehouse',
  data() {
    return {
      warehouseData: [],
      warehouseListLoading: false,
      selectDeleteId: 0,
      currentPage: 1,
      currentTotal: 0,
      dialogVisible: false
    }
  },
  methods: {
    generateCustomizeString,
    editClick(row) {
      this.$router.push({
        name: 'EditWarehouse',
        params: { warehouseId: row.id }
      })
    },
    createClick() {
      this.$router.push({ name: 'CreateWarehouse' })
    },
    refreshClick() {
      this.fetchData(this.currentPage)
    },
    deleteClick(row) {
      this.selectDeleteId = row.id
      this.dialogVisible = true
    },
    handleCurrentChange(val) {
      this.fetchData(val)
    },
    fetchData(page) {
      if (this.warehouseListLoading) return
      this.warehouseListLoading = true

      request({
        url: '/warehouses',
        method: 'get',
        params: {
          page: page
        }
      })
        .then(response => {
          const data = response.data
          const meta = response.meta
          for (let i = 0; i < response.data.length; i++) {
            var obj = {}
            obj.id = response.data[i].id
            obj.address = response.data[i].address
            obj.name = response.data[i].name
            data[i] = obj
          }

          this.warehouseData = data
          this.currentPage = meta.current_page
          this.currentTotal = meta.total
        })
        .catch(error => {
          console.warn(error)
        })
        .finally(() => {
          this.warehouseListLoading = false
        })
    },
    deleteWarehouse() {
      if (this.selectDeleteId === 0) return
      request({
        url: 'warehouse/' + this.selectDeleteId,
        method: 'delete'
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('warehouseDeleted'),
              type: 'success'
            })
          } else {
            if (res.status === 60016) {
              this.$message.error(this.generateCustomizeString('warehouseDeletedError'))
            }
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error(this.generateCustomizeString('warehouseDeletedFailed'))
        })
        .finally(() => {
          this.fetchData(this.currentPage)
          this.dialogVisible = false
          this.selectDeleteId = 0
        })
    }
  },
  created: function() {
    this.fetchData(1)
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.refreshClick()
    }
  },
  beforeRouteEnter(to, from, next) {
    if (to.meta && to.meta.badge) {
      to.meta.badge = null
    }
    next()
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #efefef;
  // color: #333;
  text-align: left;
  line-height: 60px;
}
</style>
